import React, { useEffect, useState } from "react";
import "./Register.scss";
import Api from "../shared/Api";
import {
  dateFormat,
  EqStatusCode,
  GetRegistrationMessageKey,
} from "../shared/Common";
import history from "../shared/history";
import { FrontEndPoints } from "../shared/Common";
import {
  Form,
  Typography,
  Image,
  Tooltip,
  Progress,
  Checkbox,
  Modal,
} from "antd";
import {
  EyeInvisibleOutlined,
  EyeTwoTone,
  UserOutlined,
  UnlockFilled,
  CloseOutlined,
} from "@ant-design/icons";
import {
  EqInput,
  EqInputNumber,
  EqInputPassword,
} from "../custom/eqInput/EqInput";
import EqButton, { IEqButton } from "../custom/eqButton/EqButton";
import { EqSpace } from "../custom/eqSpace/EqSpace";
import { Professions } from "../shared/enums";
import EqToggle, { IEqToggle } from "../custom/eqToggle/EqToggle";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import EqDatePicker, {
  IDatePickerOptions,
} from "../custom/eqDatePicker/EqDatePicker";
import moment from "moment";

export const Register = (props: any) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  var defaultUserVals = {
    fullName: "",
    email: "",
    repeatEmail: "",
    password: "",
    repeatPassword: "",
    userType: Professions.trainer,
    isUnderAge: false,
  };
  var defaultFeedback = { error: "", success: "" };
  const [under18ModalVisible, setUnder18ModalVisible] = useState(false);

  const [formData, setFormData] = useState(defaultUserVals) as any;
  const [feedback, setFeedback] = useState(defaultFeedback) as any;
  const [showInviteTxt, setShowInviteTxt] = useState(false);
  const [isUnderAge, setIsUnderAge] = useState(false);
  const { Text, Title } = Typography;
  const [showNote, setShowNote] = useState(true);
  const [progressPercent, setProgressPercent] = useState(0);

  const handleCloseNote = () => {
    setShowNote(false);
  };

  const tailLayout = {
    wrapperCol: { offset: 4, span: 16 },
  };

  const togglerProps: IEqToggle = {
    items: [
      { key: "2", value: t("trainer") },
      { key: "8", value: t("school") },
      { key: "7", value: t("eventHolder") },
      { key: "3", value: t("student") },
    ],
    changeFunc: (value: string) => {
      setFormData({ ...formData, userType: +value });
    },
    defaultSelectedValue: formData.userType,
    classNames: "jagged",
    radioGroupClasses: "eq-block",
    isFlex: true,
    name: "userType",
  };

  function increase() {
    let percent = progressPercent + 17;
    console.log(progressPercent, percent);
    if (percent > 100) {
      percent = 100;
    }
    setProgressPercent(percent);
  }

  function decline() {
    let percent = progressPercent - 17;
    console.log(progressPercent, percent);
    if (percent < 0) {
      percent = 0;
    }
    setProgressPercent(percent);
  }

  const Under18Model = (
    <Modal
      className="register-popup"
      open={under18ModalVisible}
      onOk={() => setUnder18ModalVisible(false)}
      onCancel={() => setUnder18ModalVisible(false)}
    >
      {/* <img className="logo-home" src="images/Logo-home.svg" /> */}

      <h2 className="popup-heading">{t("note")}</h2>
      <p className="register-popup-text">
        {t("ifUnder18")} <br />
        {t("addParentaccount")}
      </p>
    </Modal>
  );

  const NavigateToLogin = (e: any) => {
    // e.stopPropagation();

    const params = new URLSearchParams(window.location.search);

    if (params != null || undefined) {
      var trainerKey = params.get("ByTrainer") || params.get("trainerKey");

      if (trainerKey) {
        // navigate(`${FrontEndPoints.login}?key=${trainerKey}`);
        navigate(FrontEndPoints.login, {
          state: { trainerKey: trainerKey, prevPath: location.pathname },
        });
      } else {
        navigate(FrontEndPoints.login, {
          state: { prevPath: location.pathname, },
        });
      }
    }
  };

  const dobProps: IDatePickerOptions = {
    isSuffixIcon: true,
    isBordered: true,
    defaultValue: formData?.dateOfBirth,
    placeHolder: "Date",
    classNames: "eq-event",
    onChangeFunc: (date: any) => {
      setFormData({ ...formData, dateOfBirth: moment(date) });
    },
  };

  useEffect(() => {
    selectProfession(Professions.trainer);
    // const params = new URLSearchParams(props.location?.search);
    const params = new URLSearchParams(window.location.search);

    if (params != null || undefined) {
      var professionKey = params.get("profession");
      var email = params.get("email");
      var trainerKey = params.get("trainerKey");
      var schoolKey = params.get("schoolKey");
      if (professionKey && email) {
        setShowInviteTxt(true);
        setFormData({ ...formData, email: email, userType: +professionKey });
      } else if (trainerKey && professionKey) {
        setShowInviteTxt(true);
        setFormData({
          ...formData,
          trainerKey: trainerKey,
          userType: +professionKey,
        });
      } else if (schoolKey && professionKey) {
        setShowInviteTxt(true);
        setFormData({
          ...formData,
          trainerKey: schoolKey,
          userType: +professionKey,
        });
      } else if (professionKey) {
        selectProfession(professionKey);
      }
    }
  }, []);

  const onFinishFailed = (errorInfo: any) => { };

  const validateRegisterForm = (): string => {
    console.log(defaultUserVals);

    var output = "";
    if (!formData.fullName || !formData.fullName.length) {
      output += t("userNameError");
    } else if (!formData.email || !formData.email.length) {
      output += t("emailError");
    } else if (!formData.repeatEmail || !formData.repeatEmail.length) {
      output += t("repeatEmailError");
    } else if (!formData.password || !formData.password.length) {
      output += t("passwordError");
    } else if (formData.email != formData.repeatEmail) {
      output += t("emailMatchError");
    } else if (formData.password.length < 6) {
      output += t("pwdGrtThanSix");
    } else if (!formData.repeatPassword || !formData.repeatPassword.length) {
      output += t("repeatPasswordError");
    } else if (formData.password != formData.repeatPassword) {
      output += t("repeatPasswordMatchError");
    } else if (!formData.userType || !formData.userType.toString().length) {
      output += t("userTypeError");
    } 
    // else if (!isUnderAge && formData.userType == Professions.student) {
    //   if (!formData.personalNumber || !formData.personalNumber.length)
    //     output += t("personalNumberError");
    // } 
    
    // else if (isUnderAge && formData.userType == Professions.student) {
    //   if (!formData.dateOfBirth) output += t("dateOfBirthError");
    // }
    else if (formData.userType == Professions.student) {
      if (!formData.dateOfBirth) output += t("dateOfBirthError");
    }
    return output;
  };

  const RegisterUser = (event: any) => {
    var res = validateRegisterForm();
    //console.log(formData);
    if (!res.length) {
      setFeedback(defaultFeedback);
      // format
      var apiFormData = { ...formData };
      apiFormData.dateOfBirth = moment(formData.dateOfBirth, dateFormat)
        .utc()
        .valueOf();

      var path = "Account/Register";

      const params = new URLSearchParams(window.location.search);
      if (params != null || undefined) {
        var trainerKey = params.get("trainerKey");
        var schoolKey = params.get("schoolKey");

        if (trainerKey) {
          path = "Account/RegisterStudentByInvitedLink";
        } else if (schoolKey) {
          path = "Account/RegisterStudentBySchoolInvitedLink";
        }
      }
      Api.post(path, apiFormData).then(
        (response) => {
          if (response && (response.status == 200 || response.status == 202)) {
            setFormData(defaultUserVals);
            setFeedback({
              ...feedback,
              success: t(GetRegistrationMessageKey(response.status)),
            });
            NavigateToLogin(response.status);
          } else {
            showError(
              t(GetRegistrationMessageKey(EqStatusCode.preConditionFailed409))
            );
          }
        },
        (err) => {
          console.log(err.response);
          showError(t(GetRegistrationMessageKey(err.response.status)));
        }
      );
    } else {
      showError(res);
    }
    //setFeedback({ ...feedback, success: t(GetRegistrationMessageKey(200)) });
  };

  const buttonProps: IEqButton = {
    classNames: "eq-block",
  };

  const selectProfession = (profession: any) => {
    setFormData({ ...formData, userType: profession });
  };

  const showError = (msg: string) => {
    setFeedback({ ...feedback, error: msg });
  };

  const validateEmails = (emailTxt: string, repeatEmailTxt: string) => {
    if (emailTxt != repeatEmailTxt) {
      showError(t("emailMatchError"));
    } else {
      setFeedback(defaultFeedback);
    }

    return true;
  };

  const validateRepeatPassword = (psd: string, repeatPsd: string) => {
    if (psd != repeatPsd) {
      showError(t("passwordMatchError"));
    } else {
      setFeedback(defaultFeedback);
    }

    return true;
  };

  const validateAndSetEmail = (evt: any): void => {
    validateEmails(evt.target.value, formData.repeatEmail);

    setFormData({ ...formData, email: evt.target.value });
  };
  const validateAndSetRepeatEmail = (evt: any): void => {
    validateEmails(evt.target.value, formData.email);

    setFormData({ ...formData, repeatEmail: evt.target.value });
  };

  const validateAndSetPassword = (evt: any): void => {
    if (evt.target.value.length < 7) {
      evt.target.value.length > formData.password.length
        ? increase()
        : decline();
    }
    if (evt.target.value.length < 6) {
      showError(t("pwdGrtThanSix"));
    }

    setFormData({ ...formData, password: evt.target.value });
  };
  const validateAndSetRepeatPassword = (evt: any): void => {
    validateRepeatPassword(evt.target.value, formData.password);

    setFormData({ ...formData, repeatPassword: evt.target.value });
  };

  const handleOnChangePersonalNumber = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value: inputValue } = e.target;
    
    const reg = /^\d+$/;
    if (reg.test(inputValue) || inputValue === "") {
      setFormData({ ...formData, personalNumber: e.target.value });
    }
  };

  return (
    <div className="register">
      <div className="eq-form-wrapper">
        {showInviteTxt && (
          <Text className="show valid invite-txt">{t("")}</Text>
          // <Text className="show valid invite-txt">{t("inviteHeading")}</Text>
        )}
        {/* <Image className="eq-logo" src="logo.png" /> */}
        <Title className="custom-title">{t("createProfile")}</Title>
        <Form
          {...tailLayout}
          layout="vertical"
          size="small"
          onFinish={RegisterUser}
          onFinishFailed={onFinishFailed}
        >
          <p className="label">{t("Iama")}:</p>
          <div className="eq-form-item-wrapper">
            <EqToggle {...togglerProps}></EqToggle>
          </div>
          <div className="eq-form-item-wrapper">
            <p className="label">{t("provideBasicDetails")}:</p>
          </div>
          <div className="eq-form-item-wrapper">
            <EqInput
              name="fullName"
              placeholder="Full Name"
              prefix={<UserOutlined />}
              value={formData.fullName}
              onChange={(e: any) =>
                setFormData({ ...formData, fullName: e.target.value })
              }
            />
          </div>
          <div className="eq-form-item-wrapper">
            <p className="password-label">{t("enterEmail")}</p>
            <EqInput
              name="email"
              type="email"
              placeholder={t("Email adress ")}
              prefix={<UserOutlined />}
              value={formData.email}
              onChange={(e: any) => validateAndSetEmail(e)}
            />
          </div>
          <div className="eq-form-item-wrapper">
            <p className="repeat-password-label">{t("ReEnterEmail")}</p>
            <EqInput
              name="email"
              type="email"
              placeholder={t("Email adress ")}
              prefix={<UserOutlined />}
              value={formData.repeatEmail}
              onChange={(e: any) => validateAndSetRepeatEmail(e)}
              onKeyUp={(e: any) => validateAndSetRepeatEmail(e)}
            />
          </div>
          <div className="eq-form-item-wrapper">
            <p className="password-label">{t("CreateYourPassword")}</p>
            <EqInputPassword
              name="password"
              value={formData.password}
              placeholder={t("inputPassword")}
              iconRender={(visible: any) =>
                visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
              }
              prefix={<UnlockFilled />}
              onChange={(e: any) => validateAndSetPassword(e)}
            />
          </div>

            {/* <div className="eq-form-item-wrapper">
                        <p className="password-label">Re Enter password</p>
                        <EqInputPassword
                            name="password"
                            value={formData.repeatPassword}
                            placeholder={t("Input password")}
                            iconRender={(visible: any) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                            prefix={<UnlockFilled />}
                            onChange={(e: any) => validateAndSetPassword(e)}
                        />
                    </div> */}
          <div className="eq-form-item-wrapper">
            <Tooltip title="2 done / 0 in progress / 4 to do">
              <Progress
                percent={progressPercent}
                success={{ percent: progressPercent, strokeColor: "#FF8838" }}
                type="line"
                strokeWidth={4}
                trailColor="#FFFFFF"
                strokeLinecap="round"
                showInfo={false}
              />
            </Tooltip>
            <div className="eq-form-item-wrapper">
              <p className="repeat-password-label">
                {t("reRnterYourPassword")}
              </p>
              <EqInputPassword
                id="repeatPassword"
                name="repeatPassword"
                placeholder={t("repeatPassword")}
                iconRender={(visible: any) =>
                  visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                }
                prefix={<UnlockFilled />}
                value={formData.repeatPassword}
                onChange={(e: any) =>
                  setFormData({ ...formData, repeatPassword: e.target.value })
                }
                onKeyUp={(e: any) => validateAndSetRepeatPassword(e)}
              />
            </div>
          </div>

          {/* Commenting Personal Number for now -- to make process easy for now */}
          {/* just take date of birth for the use for now */}

          <div className="eq-form-item-wrapper">
                  <p className="label-left">{t("dateofBirth")}</p>
                  <EqDatePicker
                    // isDisabled={isStudent}
                    {...dobProps}
                  ></EqDatePicker>
                </div>

          {/* {formData.userType == Professions.student && (
            <>
              {isUnderAge ? (
                <div className="eq-form-item-wrapper">
                  <p className="label-left">{t("dateofBirth")}</p>
                  <EqDatePicker
                    // isDisabled={isStudent}
                    {...dobProps}
                  ></EqDatePicker>
                </div>
              ) : (
                <>
                  <div className="eq-form-item-wrapper">
                  <p className="label-left">{t("personalNumber")}</p>
                  <EqInput
                    name="personalNumber"
                    placeholder="e.g., 1234567"
                    prefix={<UserOutlined />}
                    value={formData?.personalNumber}
                    onChange={(e: any) => {
                      
                      handleOnChangePersonalNumber(e);
                    }}
                  />
                </div>
                </>
              )}

              <div className="eq-form-item-wrapper">
                <Checkbox
                  className="label"
                  onChange={(e: any) => {
                    setIsUnderAge(e.target.checked);
                    setFormData({ ...formData, isUnderAge: e.target.checked });
                    setUnder18ModalVisible(e.target.checked);
                  }}
                >
                  {t("IAmUnder18")}
                </Checkbox>
              </div>
            </>
          )} */}

          <div className="eq-form-item-wrapper">
            {feedback.error.length > 0 && (
              <Text id="merrorMsg" className="show invalid">
                {feedback.error}
              </Text>
            )}
            {feedback.success.length > 0 && (
              <Text id="msuccessMsg" className="show valid">
                {feedback.success}
              </Text>
            )}
          </div>
          <div className="eq-form-item-wrapper">
            <EqSpace direction="vertical" style={{ padding: "1% 8%" }}>
              <Text>
                {t("registerAutomaticaly")}{" "}
                <a className="eq-anchor">
                  <u>{t("privacy")}</u>
                </a>{" "}
                {t("and")}{" "}
                <a className="eq-anchor">
                  <u>{t("terms")}</u>
                </a>
              </Text>
            </EqSpace>
          </div>
          <div className="eq-form-item-wrapper">
            <EqButton
              type="primary"
              htmlType="submit"
              centered="centered"
              {...buttonProps}
            >
              {t("register")}
            </EqButton>
          </div>
          <div className="eq-form-item-wrapper">
            <EqSpace
              direction="vertical"
              style={{
                width: "100%",
                padding: "1% 8%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <a className="eq-anchor label" href={FrontEndPoints.login}>
                <u>{t("alreadyRegistered")}</u>
              </a>
            </EqSpace>
          </div>
        </Form>
      </div>
      {Under18Model}
    </div>
  );
};

export default Register;
